import * as React from "react";
const SvgSizeMe = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 11.667, height: 11.667, x: 4.167, y: 4.167, stroke: "currentColor", strokeWidth: 1.25, rx: 5.833 }));
export default SvgSizeMe;
